<template>
<v-app id="inspire" style="background:#F9F9F9;">
<vue-header-admin></vue-header-admin>
    <v-main>
    <v-container fluid class="px-6 py-6">
        <v-row
            align="center"
            justify="center"
          >
            <v-col cols="12" md="12">
              <v-card class="card-shadow border-radius-xl mt-2" id="basic" style="margin-bottom: 100px;">
                <v-card-text >
                  <v-row>
                    <v-col
                      cols="6"
                      md="6"
                    >
                    <h5 class="text-h4 font-weight-bold text-typo">Voice Agent Leads({{totalCount}})</h5>
                    </v-col>
                    <v-col
                      cols="6"
                      md="6"
                    >
                    <rotate-loader class="mt-3" :loading="loading" color="#1D75F4"></rotate-loader>
                    </v-col>
                     <v-col cols="12"
                      md="6" >
                        <v-spacer></v-spacer>
                            <v-text-field
                               v-model="search"
                                label="Search"
                                single-line
                                clearable
                                hide-details
                            >
                                <template v-slot:append>

                                </template>
                                <template v-slot:append-outer>
                                    <v-btn
                                    color="#4CAF50"
                        class="
                         ont-weight-bolder
                          btn-default
                          py-4
                          px-8
                          ms-auto
                          mt-sm-auto mt-4

                                      "
                                        small
                                        @click="getLeads"
                                    >
                                        Submit
                                    </v-btn>
                                </template>
                            </v-text-field>
                    </v-col>
                    <v-col cols="12"
                      md="6">

                    </v-col>
                    <v-col cols="12"
                      md="12">


                        <v-data-table
                            :headers="headers_leads"
                            :options.sync="datatable_options"
                            :items="leads"
                            v-model="selectedItems"
                            show-select
                            loading-text="Loading... Please wait"
                            :page.sync="page"
                            :items-per-page="itemsPerPage"
                            class="table"
                            :footer-props="{
                                    firstIcon: '',
                                    lastIcon: '',
                                    prevIcon: '',
                                    nextIcon: '',
                                    'page-text': false,
                                    'items-per-page-options': [10, 50, 100,-1]
                                  }"
                        >
                    <template v-slot:item.name="{ item }">
                      <a style="text-decoration: none;color: #2196F3;" :href="'/admin/client-profile-detail/'+item.user_id">
                        {{item.first_name}} {{item.last_name}}
                      </a>
                    </template>
                    <template v-slot:item.status="{ item }">
                      {{item.status == 1 ? 'Active' :'Inactive'}}
                    </template>
                    <template v-slot:item.email="{ item }">
                      {{item.email ? item.email : 'Not Available'}}
                    </template>
                    <template v-slot:item.phone="{ item }">
                      {{item.phone_m ? item.phone_m : "Not Available"}}
                    </template>
                    <template v-slot:item.created_at="{ item }">
                      {{formatDate(item.created_at)}}
                    </template>
                    <template v-slot:item.memo="{ item }">
                      <div style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                        {{item.memo || 'No memo'}}
                      </div>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        class="mx-2"
                        text
                        dark
                        @click="viewLead(item)"
                        x-small
                        color="blue"
                      >
                        <v-icon size="20" class="material-icons-round opacity-10" dark>
                          visibility
                        </v-icon>
                      </v-btn>
                    </template>
                        </v-data-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
    </v-container>
    <vue-footer-admin></vue-footer-admin>
</v-main>

</v-app>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import ClipLoader from 'vue-spinner/src/PulseLoader.vue';

export default {
  name: "Leads",
  components: {
    'RotateLoader': ClipLoader
  },
  data() {
    return {
      leads: [],
      loading: true,
      search: "",
      selectedItems: [],
      page: 1,
      itemsPerPage: 10,
      datatable_options: {},
      offset: 0,
      totalCount: 0,
      pageCount: 1,
      headers_leads: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Email', value: 'email', sortable: true },
        { text: 'Phone', value: 'phone', sortable: true },
        { text: 'Status', value: 'status', sortable: true },
        { text: 'Created Date', value: 'created_at', sortable: true },
        { text: 'Memo', value: 'memo', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    header() {
      return {
        headers: {
          Authorization: "Bearer " + localStorage.getItem('token')
        }
      };
    }
  },
  mounted() {
    this.getLeads();
  },
  watch: {
    datatable_options: {
      handler() {
        this.getLeads();
      },
      deep: true
    }
  },
  methods: {
    formatDate(value) {
      return moment(value).format("DD MMM YYYY");
    },
    getLeads() {
      this.loading = true;
      this.offset = (this.page - 1) * this.datatable_options.itemsPerPage;
      
      let req = {
        limit: this.datatable_options.itemsPerPage,
        offset: this.offset,
        sort: this.datatable_options.sortBy,
        sortDesc: this.datatable_options.sortDesc && this.datatable_options.sortDesc[0] == false ? 'ASC' : 'DESC',
        search: this.search
      };

      axios({
        method: "POST",
        url: "/api/get-leads",
        data: req,
        headers: {
          Authorization: "Bearer " + localStorage.getItem('token')
        }
      })
      .then(response => {
        let data = response.data;
        if (response.data.flag) {
          console.log(data);
          this.leads = data.data;
          this.pageCount = data.total_page;
          this.totalCount = data.count;
          console.log(this.leads);
          this.loading = false;
        } else {
          Vue.$toast.error(data.message || 'Error loading leads', {
            position: 'top-right'
          });
          this.loading = false;
        }
      })
      .catch(err => {
        Vue.$toast.error("Error loading leads", {
          position: 'top-right'
        });
        this.loading = false;
      });
    },
    viewLead(item) {
      this.$router.push('/admin/client-profile-detail/' + item.user_id);
    }
  }
};
</script>

<style>
.table {
  background-color: transparent !important;
}
.card-shadow {
  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05) !important;
}
.border-radius-xl {
  border-radius: 1rem !important;
}
.text-typo {
  color: #344767 !important;
}
</style>
